// @systeme: interface
// Les formulations de référence (docs/produit.md §7). On parle à une personne fatiguée :
// simple, chaleureux, bref. Jamais de culpabilisation, jamais de jargon.
export const textes = {
  rienDUrgent: 'Rien d’urgent aujourd’hui.',
  toutEstGarde: 'Tout ce que tu notes est bien gardé.',
  cestNote: 'C’est noté.',
  erreurTechnique: 'Ça n’a pas marché de mon côté. Je réessaie dans un instant.',
  pasDeReseau: 'Pas de réseau pour le moment. Je réessaie dès qu’il revient.',
  merciRetour: 'Merci, c’est noté. Ça nous aide vraiment.',
  quotaRestant: (n: number, quoi: string) => `Il te reste ${n} ${quoi} ce mois-ci.`,
  quotaEpuise: (quoi: string) =>
    `Plus de ${quoi} ce mois-ci — tu peux continuer à écrire, tout marche.`,
  assistantEnPause:
    'L’assistant se repose : ton essai est terminé. Tout ce que tu notes est bien gardé, et tout marche à la main.',
  paiementOk: 'Merci ! Ton abonnement se met en place, l’écran le montrera dans un instant.',
  paiementAnnule: 'Pas de paiement : rien ne change, tout continue de marcher.',
} as const;
